import React, {useState} from 'react';
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import { navigate } from "@reach/router"
import db from '../firebase'

const CommerceForm = (props) => {

    const [name, setName] = useState('')
    const [fathername, setFathername] = useState('')
    const [mothername, setMothername] = useState('')
    const [guardianname, setGuardianname] = useState('')
    const [dob, setDob] = useState('')
    const [caste, setCaste] = useState('DEFAULT')
    const [nationality, setNationality] = useState('')
    const [religion, setReligion] = useState('')
    const [sex, setSex] = useState('DEFAULT')
    const [ward_permanent, setWard_permanent] = useState('')
    const [postoffice_permanent, setPostoffice_permanent] = useState('')
    const [district_permanent, setDistrict_permanent] = useState('')
    const [state_permanent, setState_permanent] = useState('')
    const [pincode_permanent, setPincode_permanent] = useState('')
    const [phone_permanent, setPhone_permanent] = useState('')
    const [landline_permanent, setLandline_permanent] = useState('')
    const [careof_present, setCareof_present] = useState('')
    const [ward_present, setWard_present] = useState('')
    const [postoffice_present, setPostoffice_present] = useState('')
    const [district_present, setDistrict_present] = useState('')
    const [state_present, setState_present] = useState('')
    const [phone_present, setPhone_present] = useState('')
    const [school, setSchool] = useState('')
    const [regnumber, setRegnumber] = useState('')
    const [regyear, setRegyear] = useState('')
    const [gapstart, setGapstart] = useState('')
    const [gapend, setGapend] = useState('')
    const [roll, setRoll] = useState('')
    const [number, setNumber] = useState('')
    const [rollyear, setRollyear] = useState('')
    const [subject1, setSubject1] = useState('')
    const [subject2, setSubject2] = useState('')
    const [subject3, setSubject3] = useState('')
    const [subject4, setSubject4] = useState('')
    const [subject5, setSubject5] = useState('')
    const [subject6, setSubject6] = useState('')
    const [subject7, setSubject7] = useState('')
    const [totalmarks1, setTotalmarks1] = useState('')
    const [totalmarks2, setTotalmarks2] = useState('')
    const [totalmarks3, setTotalmarks3] = useState('')
    const [totalmarks4, setTotalmarks4] = useState('')
    const [totalmarks5, setTotalmarks5] = useState('')
    const [totalmarks6, setTotalmarks6] = useState('')
    const [totalmarks7, setTotalmarks7] = useState('')
    const [obtained1, setObtained1] = useState('')
    const [obtained2, setObtained2] = useState('')
    const [obtained3, setObtained3] = useState('')
    const [obtained4, setObtained4] = useState('')
    const [obtained5, setObtained5] = useState('')
    const [obtained6, setObtained6] = useState('')
    const [obtained7, setObtained7] = useState('')
    const [grandtotal, setGrandtotal] = useState('')
    const [totalobtained, setTotalobtained] = useState('')
    const [division, setDivision] = useState('')
    const [percentage, setPercentage] = useState('')
    const [preference1, setPreference1] = useState('')
    const [preference2, setPreference2] = useState('')
    const [compulsory, setCompulsory] = useState('')
    const [electives, setElectives] = useState('')
    const [honours, setHonours] = useState('')
    const [core1, setCore1] = useState('')
    const [core2, setCore2] = useState('')


    const onNameChange = (event) =>{setName(event.target.value)}
    const onFathernameChange = (event) =>{setFathername(event.target.value)}
    const onMothernameChange = (event) =>{setMothername(event.target.value)}
    const onGuardiannameChange = (event) =>{setGuardianname(event.target.value)}
    const onDobChange = (event) =>{setDob(event.target.value)}
    const onCasteChange = (event) =>{setCaste(event.target.value)}
    const onNationalityChange = (event) =>{setNationality(event.target.value)}
    const onReligionChange = (event) =>{setReligion(event.target.value)}
    const onSexChange = (event) =>{setSex(event.target.value)}
    const onWard_permanentChange = (event) =>{setWard_permanent(event.target.value)}
    const onPostoffice_permanentChange = (event) =>{setPostoffice_permanent(event.target.value)}
    const onDistrict_permanentChange = (event) =>{setDistrict_permanent(event.target.value)}
    const onState_permanentChange = (event) =>{setState_permanent(event.target.value)}
    const onPincode_permanentChange = (event) =>{setPincode_permanent(event.target.value)}
    const onPhone_permanentChange = (event) =>{setPhone_permanent(event.target.value)}
    const onLandline_permanentChange = (event) =>{setLandline_permanent(event.target.value)}
    const onCareof_presentChange = (event) =>{setCareof_present(event.target.value)}
    const onWard_presentChange = (event) =>{setWard_present(event.target.value)}
    const onPostoffice_presentChange = (event) =>{setPostoffice_present(event.target.value)}
    const onDistrict_presentChange = (event) =>{setDistrict_present(event.target.value)}
    const onState_presentChange = (event) =>{setState_present(event.target.value)}
    const onPhone_presentChange = (event) =>{setPhone_present(event.target.value)}
    const onSchoolChange = (event) =>{setSchool(event.target.value)}
    const onRegnumberChange = (event) =>{setRegnumber(event.target.value)}
    const onRegyearChange = (event) =>{setRegyear(event.target.value)}
    const onGapstartChange = (event) =>{setGapstart(event.target.value)}
    const onGapendChange = (event) =>{setGapend(event.target.value)}
    const onRollChange = (event) =>{setRoll(event.target.value)}
    const onNumberChange = (event) =>{setNumber(event.target.value)}
    const onRollyearChange = (event) =>{setRollyear(event.target.value)}
    const onSubject1Change = (event) =>{setSubject1(event.target.value)}
    const onSubject2Change = (event) =>{setSubject2(event.target.value)}
    const onSubject3Change = (event) =>{setSubject3(event.target.value)}
    const onSubject4Change = (event) =>{setSubject4(event.target.value)}
    const onSubject5Change = (event) =>{setSubject5(event.target.value)}
    const onSubject6Change = (event) =>{setSubject6(event.target.value)}
    const onSubject7Change = (event) =>{setSubject7(event.target.value)}
    const onTotalmarks1Change = (event) =>{setTotalmarks1(event.target.value)}
    const onTotalmarks2Change = (event) =>{setTotalmarks2(event.target.value)}
    const onTotalmarks3Change = (event) =>{setTotalmarks3(event.target.value)}
    const onTotalmarks4Change = (event) =>{setTotalmarks4(event.target.value)}
    const onTotalmarks5Change = (event) =>{setTotalmarks5(event.target.value)}
    const onTotalmarks6Change = (event) =>{setTotalmarks6(event.target.value)}
    const onTotalmarks7Change = (event) =>{setTotalmarks7(event.target.value)}
    const onObtained1Change = (event) =>{setObtained1(event.target.value)}
    const onObtained2Change = (event) =>{setObtained2(event.target.value)}
    const onObtained3Change = (event) =>{setObtained3(event.target.value)}
    const onObtained4Change = (event) =>{setObtained4(event.target.value)}
    const onObtained5Change = (event) =>{setObtained5(event.target.value)}
    const onObtained6Change = (event) =>{setObtained6(event.target.value)}
    const onObtained7Change = (event) =>{setObtained7(event.target.value)}
    const onGrandtotalChange = (event) =>{setGrandtotal(event.target.value)}
    const onTotalobtainedChange = (event) =>{setTotalobtained(event.target.value)}
    const onDivisionChange = (event) =>{setDivision(event.target.value)}
    const onPercentageChange = (event) =>{setPercentage(event.target.value)}
    const onPreference1Change = (event) =>{setPreference1(event.target.value)}
    const onPreference2Change = (event) =>{setPreference2(event.target.value)}
    const onCompulsoryChange = (event) =>{setCompulsory(event.target.value)}
    const onElectivesChange = (event) =>{setElectives(event.target.value)}
    const onHonoursChange = (event) =>{setHonours(event.target.value)}
    const onCore1Change = (event) =>{setCore1(event.target.value)}
    const onCore2Change = (event) =>{setCore2(event.target.value)}


    const onCreatePost = () =>{

        let tablename = props.clg
        if(props.clg != 'snr'|| props.clg != 'jnr')
              tablename = 'xxx'
        let postdef = db.collection(tablename)
       // let postdef = db.collection('sss')

        console.log("got to onCreate")
        let payload = {
                 name, fathername, mothername, guardianname, dob, caste, nationality, religion,
                sex, ward_permanent, postoffice_permanent, district_permanent, state_permanent,
                pincode_permanent, phone_permanent, landline_permanent, careof_present, ward_present,
                postoffice_present, district_present, state_present, phone_present, school, regnumber,
                regyear, gapstart, gapend, roll, number, rollyear, subject1, subject2, subject3, subject4,
                subject5, subject6, subject7, totalmarks1, totalmarks2, totalmarks3, totalmarks4, totalmarks5,
                totalmarks6, totalmarks7, obtained1, obtained2, obtained3, obtained4, obtained5, obtained6, obtained7,
                grandtotal, totalobtained, division, percentage, preference1, preference2, compulsory, electives, honours, core1, core2
        }
        console.log("val - ", validated)
        console.log("payload - ",payload)


        event.preventDefault();
        event.stopPropagation();
        
        postdef.add(payload)
            .then(function(doc) {
                console.log("Document Uploaded successfully!", doc.id)

                    //navigate to confirmation screen
                    navigate(`/ServiceStatus/${doc.id}`)
           })


    }



    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
      const form = event.currentTarget;
      if (form.checkValidity() === false) {
        console.log("got to onCreate320")
        event.preventDefault();
        event.stopPropagation();
      }
      else
      {
        console.log("got to onCreate0")
        event.preventDefault();
        event.stopPropagation();
        onCreatePost()
      }
      setValidated(true); 

      event.preventDefault();
      event.stopPropagation();
    };
    
    

    return(
        <div className="page_container">
            
            <div className="create_post_container container border-dark special-card" style={{marginTop:"2rem" ,paddingTop:"1rem", paddingBottom:"3rem"}}>
                <div className="page_header_container">
                    <h1 className="text-dark font-weight-bold">Admission Form (Degree College - Commerce)</h1>
                    <hr className="mb-3 mt-0 border-info"/>
                </div>
                <div className="post_inputs_container">
                    <div className="post_input_container">
                    
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <legend  className="text-info text-center">
                                Note: Make sure you have read all the instructions carefully before applying this form!
                                </legend>
                            <hr />

                            <legend  className="lead text-primary my-0">Provide Your Personal Info</legend>
                            
                            <Form.Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="validationCustom01">
                                    <Form.Label className="required_label">Name of the Applicant </Form.Label>
                                    <Form.Control 
                                        value={name} onChange={onNameChange}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Example: Abhimanyu Zaman"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom02">
                                    <Form.Label className="required_label">Father's Name </Form.Label>
                                    <Form.Control 
                                        value={fathername} onChange={onFathernameChange}
                                        className="border-info" 
                                        required
                                        type="text"
                                        placeholder="Example: Asif Zaman"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom03">
                                    <Form.Label className="required_label">Mother's Name</Form.Label>
                                    <Form.Control 
                                        value={mothername} onChange={onMothernameChange}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Example: Jyoti Zaman"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom04">
                                    <Form.Label >Guardian's Name </Form.Label>
                                    <Form.Control 
                                        value={guardianname} onChange={onGuardiannameChange}
                                        className="border-info" 
                                        type="text"
                                        placeholder="Example: Hrishik Rai"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row >
                            <Form.Row className="mb-3">
                                <Form.Group as={Col} md="4" controlId="validationCustom05">
                                    <Form.Label className="required_label">Date of Birth </Form.Label>
                                    <Form.Control 
                                        value={dob} onChange={onDobChange}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="dd/mm/yyyy"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom06">
                                    <Form.Label className="required_label">Caste </Form.Label>
                                    <Form.Control
                                        defaultValue={caste} 
                                        onChange={onCasteChange} 
                                        className="border-info"
                                        as="select"
                                        required
                                    >
                                        <option value="DEFAULT" disabled>Please select</option>
                                        <option value="General" >General</option>
                                        <option value="OBC" >OBC</option>
                                        <option value="MOBC" >MOBC</option>
                                        <option value="SC" >SC</option>
                                        <option value="ST(P)" >ST(P)</option>
                                        <option value="ST(H)" >ST(H)</option>
                                    </Form.Control>
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom07">
                                    <Form.Label className="required_label">Nationality</Form.Label>
                                    <Form.Control 
                                        value={nationality} onChange={onNationalityChange}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Example: Indian"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom08">
                                    <Form.Label className="required_label">Religion</Form.Label>
                                    <Form.Control 
                                        value={religion} onChange={onReligionChange}
                                        className="border-info"
                                        required 
                                        type="text"
                                        placeholder="Example: Hinduism"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom09">
                                    <Form.Label className="required_label">Sex </Form.Label>
                                    <Form.Control
                                        defaultValue={sex} 
                                        onChange={onSexChange} 
                                        className="border-info"
                                        as="select"
                                        required
                                    >
                                        <option value="DEFAULT" disabled>Please select</option>
                                        <option value="Male" >Male</option>
                                        <option value="Female" >Female</option>
                                    </Form.Control>
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row >

                                <legend  className="lead text-primary">Your Permanent Addres Details</legend>
                            <Form.Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="validationCustom10">
                                    <Form.Label className="required_label">Ward/Village</Form.Label>
                                    <Form.Control 
                                        value={ward_permanent} onChange={onWard_permanentChange}                            
                                        className="border-info" 
                                        type="text" 
                                        placeholder="Village" 
                                        required 
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid Village.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom11">
                                    <Form.Label className="required_label">Post office</Form.Label>
                                    <Form.Control 
                                        value={postoffice_permanent} onChange={onPostoffice_permanentChange}
                                        className="border-info" 
                                        type="text" 
                                        placeholder="Postoffice" 
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid Postoffice.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom12">
                                    <Form.Label className="required_label">District</Form.Label>
                                    <Form.Control 
                                        value={district_permanent} onChange={onDistrict_permanentChange} 
                                        className="border-info" 
                                        type="text" 
                                        placeholder="District" 
                                        required 
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid District.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom13">
                                    <Form.Label className="required_label">State </Form.Label>
                                    <Form.Control 
                                        value={state_permanent} onChange={onState_permanentChange}
                                        className="border-info" 
                                        placeholder="State"
                                        required
                                        type="text"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom14">
                                    <Form.Label className="required_label">Pincode </Form.Label>
                                    <Form.Control 
                                        value={pincode_permanent} onChange={onPincode_permanentChange}
                                        className="border-info" 
                                        placeholder="PIN"
                                        required
                                        type="number"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom15">
                                    <Form.Label className="required_label">Phone Number </Form.Label>
                                    <Form.Control 
                                        value={phone_permanent} onChange={onPhone_permanentChange}
                                        className="border-info" 
                                        placeholder="Phone Number"
                                        required
                                        type="number"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom16">
                                    <Form.Label>landline Number </Form.Label>
                                    <Form.Control 
                                        value={landline_permanent} onChange={onLandline_permanentChange}
                                        className="border-info" 
                                        placeholder="Landline Number"
                                        type="number"
                                    />
                                </Form.Group>
                            </Form.Row>

                                <legend  className="lead text-primary">Your Present Addres Details</legend>
                            <Form.Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="validationCustom17">
                                    <Form.Label className="required_label">In the Care of (C/O) </Form.Label>
                                    <Form.Control 
                                        value={careof_present} onChange={onCareof_presentChange}
                                        className="border-info" 
                                        placeholder="Care of"
                                        required
                                        type="text"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom18">
                                    <Form.Label className="required_label">Ward/Village</Form.Label>
                                    <Form.Control 
                                        value={ward_present} onChange={onWard_presentChange}                            
                                        className="border-info" 
                                        type="text" 
                                        placeholder="Village" 
                                        required 
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid Village.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom19">
                                    <Form.Label className="required_label">Post office</Form.Label>
                                    <Form.Control 
                                        value={postoffice_present} onChange={onPostoffice_presentChange}
                                        className="border-info" 
                                        type="text" 
                                        placeholder="Postoffice" 
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid Postoffice.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom20">
                                    <Form.Label className="required_label">District</Form.Label>
                                    <Form.Control 
                                        value={district_present} onChange={onDistrict_presentChange} 
                                        className="border-info" 
                                        type="text" 
                                        placeholder="District" 
                                        required 
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid District.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom21">
                                    <Form.Label className="required_label">State </Form.Label>
                                    <Form.Control 
                                        value={state_present} onChange={onState_presentChange}
                                        className="border-info" 
                                        placeholder="State"
                                        required
                                        type="text"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom22">
                                    <Form.Label className="required_label">Phone Number </Form.Label>
                                    <Form.Control 
                                        value={phone_present} onChange={onPhone_presentChange}
                                        className="border-info" 
                                        placeholder="Phone Number"
                                        required
                                        type="number"
                                    />
                                </Form.Group>
                            </Form.Row>
                            <hr />

                                <legend  className="lead text-primary">Your Previous Qualifications</legend>
                            <Form.Row className="mb-3">
                                <Form.Group as={Col} md="10" controlId="validationCustom23">
                                    <Form.Label className="required_label">Name of the School/College Last Attended </Form.Label>
                                    <Form.Control 
                                        value={school} onChange={onSchoolChange}
                                        className="border-info" 
                                        placeholder="Name of School"
                                        required
                                        type="text"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom24">
                                    <Form.Label className="required_label"> Council Registration Number</Form.Label>
                                    <Form.Control 
                                        value={regnumber} onChange={onRegnumberChange}                            
                                        className="border-info" 
                                        type="number" 
                                        placeholder="Registration Number" 
                                        required 
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid Registration Number.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom25">
                                    <Form.Label className="required_label">Year of Registration</Form.Label>
                                    <Form.Control 
                                        value={regyear} onChange={onRegyearChange}
                                        className="border-info" 
                                        type="number" 
                                        placeholder="Year of Registration" 
                                        required
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid Year.
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom26">
                                    <Form.Label >If any Gap in Study, Mention gap period (Gap Start) </Form.Label>
                                    <Form.Control 
                                        value={gapstart} onChange={onGapstartChange} 
                                        className="border-info" 
                                        type="number" 
                                        placeholder="Year of beginning the gap" 
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom27">
                                    <Form.Label >Ending Year of the gap </Form.Label>
                                    <Form.Control 
                                        value={gapend} onChange={onGapendChange}
                                        className="border-info" 
                                        placeholder="Year in which you ended your gap"
                                        type="number"
                                    />
                                </Form.Group>
                            </Form.Row>

                            <Form.Row className="mb-3">
                                <Form.Group as={Col} md="4" controlId="validationCustom28">
                                    <Form.Label className="required_label">Roll-No of passing H.S Final Exams </Form.Label>
                                    <Form.Control 
                                        value={roll} onChange={onRollChange}
                                        className="border-info" 
                                        placeholder="Your H.S final examination's Roll"
                                        required
                                        type="number"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom28">
                                    <Form.Label className="required_label">Roll-No of passing H.S Final Exams </Form.Label>
                                    <Form.Control 
                                        value={number} onChange={onNumberChange}
                                        className="border-info" 
                                        placeholder="H.S final examination's Roll- Number"
                                        required
                                        type="number"
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom28">
                                    <Form.Label className="required_label">Year of H.S Qualifications</Form.Label>
                                    <Form.Control 
                                        value={rollyear} onChange={onRollyearChange}
                                        className="border-info" 
                                        placeholder="The year of your H.S Exams"
                                        required
                                        type="number"
                                    />
                                </Form.Group>
                            </Form.Row >
                            <hr />

                            <legend  className="lead text-primary my-0">Marks obtained in Your H.S Final Examinations </legend>
                            <Form.Row className="mb-3">
                                <Form.Group as={Col} md="4" controlId="validationCustom29">
                                    <Form.Label className="required_label">Subjects</Form.Label>
                                    <Form.Control 
                                        value={subject1} onChange={onSubject1Change}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Subject-1"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom30">
                                    <Form.Label className='required_label'>Total Marks</Form.Label>
                                    <Form.Control 
                                        value={totalmarks1} onChange={onTotalmarks1Change}
                                        className="border-info"
                                        type="number"
                                        required
                                        placeholder="Total Marks of the Subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom31">
                                    <Form.Label className="required_label">Marks Obtained</Form.Label>
                                    <Form.Control 
                                        value={obtained1} onChange={onObtained1Change}
                                        className="border-info"
                                        required
                                        type="number"
                                        placeholder="Marks Obtained in the subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom32">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={subject2} onChange={onSubject2Change}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Subject-2"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom33">
                                    <Form.Label className='required_label'></Form.Label>
                                    <Form.Control 
                                        value={totalmarks2} onChange={onTotalmarks2Change}
                                        className="border-info"
                                        type="number"
                                        required
                                        placeholder="Total Marks of the Subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom34">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={obtained2} onChange={onObtained2Change}
                                        className="border-info"
                                        required
                                        type="number"
                                        placeholder="Marks Obtained in the subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom35">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={subject3} onChange={onSubject3Change}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Subject-3"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom36">
                                    <Form.Label className='required_label'></Form.Label>
                                    <Form.Control 
                                        value={totalmarks3} onChange={onTotalmarks3Change}
                                        className="border-info"
                                        type="number"
                                        required
                                        placeholder="Total Marks of the Subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom37">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={obtained3} onChange={onObtained3Change}
                                        className="border-info"
                                        required
                                        type="number"
                                        placeholder="Marks Obtained in the subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom38">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={subject4} onChange={onSubject4Change}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Subject-4"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom39">
                                    <Form.Label className='required_label'></Form.Label>
                                    <Form.Control 
                                        value={totalmarks4} onChange={onTotalmarks4Change}
                                        className="border-info"
                                        type="number"
                                        required
                                        placeholder="Total Marks of the Subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom40">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={obtained4} onChange={onObtained4Change}
                                        className="border-info"
                                        required
                                        type="number"
                                        placeholder="Marks Obtained in the subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom41">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={subject5} onChange={onSubject5Change}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Subject-5"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom42">
                                    <Form.Label className='required_label'></Form.Label>
                                    <Form.Control 
                                        value={totalmarks5} onChange={onTotalmarks5Change}
                                        className="border-info"
                                        type="number"
                                        required
                                        placeholder="Total Marks of the Subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom43">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={obtained5} onChange={onObtained5Change}
                                        className="border-info"
                                        required
                                        type="number"
                                        placeholder="Marks Obtained in the subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom44">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={subject6} onChange={onSubject6Change}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Subject-6"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom45">
                                    <Form.Label className='required_label'></Form.Label>
                                    <Form.Control 
                                        value={totalmarks6} onChange={onTotalmarks6Change}
                                        className="border-info"
                                        type="number"
                                        required
                                        placeholder="Total Marks of the Subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom46">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={obtained6} onChange={onObtained6Change}
                                        className="border-info"
                                        required
                                        type="number"
                                        placeholder="Marks Obtained in the subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom47">
                                    <Form.Label ></Form.Label>
                                    <Form.Control 
                                        value={subject7} onChange={onSubject7Change}
                                        className="border-info"
                                        type="text"
                                        placeholder="Subject-7 (if any)"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom48">
                                    <Form.Label ></Form.Label>
                                    <Form.Control 
                                        value={totalmarks7} onChange={onTotalmarks7Change}
                                        className="border-info"
                                        type="number"
                                        placeholder="Total Marks of the Subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="4" controlId="validationCustom49">
                                    <Form.Label ></Form.Label>
                                    <Form.Control 
                                        value={obtained7} onChange={onObtained7Change}
                                        className="border-info"
                                        type="number"
                                        placeholder="Marks Obtained in the subject"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} md="3" controlId="validationCustom50">
                                    <Form.Label className="required_label">Grand total Marks of all subject</Form.Label>
                                    <Form.Control 
                                        value={grandtotal} onChange={onGrandtotalChange}
                                        className="border-primary"
                                        required
                                        type="number"
                                        placeholder="Total Marks possible"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom51">
                                    <Form.Label className='required_label'>Total Marks You Obtained</Form.Label>
                                    <Form.Control 
                                        value={totalobtained} onChange={onTotalobtainedChange}
                                        className="border-primary"
                                        type="number"
                                        required
                                        placeholder="Total Marks you obtained"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom52">
                                    <Form.Label className="required_label">Division/Grade obtained</Form.Label>
                                    <Form.Control 
                                        value={division} onChange={onDivisionChange}
                                        className="border-primary"
                                        required
                                        type="text"
                                        placeholder="Division/Grade Obtained in H.S"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="3" controlId="validationCustom53">
                                    <Form.Label className="required_label">Percentage obtained</Form.Label>
                                    <Form.Control 
                                        value={percentage} onChange={onPercentageChange}
                                        className="border-primary"
                                        required
                                        type="number"
                                        placeholder="Percentage Obtained in H.S"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row >
                            <hr />

                                <legend  className="lead text-primary">Honours students need to study the following subjects in the B.A/B.Com first year (please read the college prospectus for the subject combination)</legend>
                            <Form.Row className="mb-3">
                                <Form.Group as={Col} md="6" controlId="validationCustom54">
                                    <Form.Label className="required_label">Preference of subject</Form.Label>
                                    <Form.Control 
                                        value={preference1} onChange={onPreference1Change}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Subject of preference-1"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom55">
                                    <Form.Label className="required_label">Compulsory Subject(AECC)</Form.Label>
                                    <Form.Control 
                                        value={compulsory} onChange={onCompulsoryChange}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Compulsory Subject-1"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom56">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={preference2} onChange={onPreference2Change}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Subject of preference-2"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom57">
                                    <Form.Label >Compulsory Subject(AECC)</Form.Label>
                                    <Form.Control 
                                        className="border-info"
                                        type="text"
                                        placeholder="English/MIL Communication (for B.A/B.com)"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} controlId="validationCustom58">
                                    <Form.Label className="required_label">Generic Elective Subject</Form.Label>
                                    <Form.Control 
                                        value={electives} onChange={onElectivesChange}
                                        className="border-info" 
                                        md="6" as="textarea" 
                                        rows="3" 
                                    />
                                </Form.Group>
                                <Form.Group as={Col} controlId="validationCustom59">
                                    <Form.Label className="required_label">Honours Subjects (Allowed in)</Form.Label>
                                    <Form.Control 
                                        value={honours} onChange={onHonoursChange}
                                        className="border-info" 
                                        md="6" as="textarea" 
                                        rows="3" 
                                    />
                                </Form.Group>
                            </Form.Row>
                                
                                <legend  className="lead text-primary">Non Honours(Regular) students need to study the following subjects in the first year B.A/B.Com(please read the college prospectus for the subject combination)</legend>
                            <Form.Row className="mb-3">
                                <Form.Group as={Col} md="4" controlId="validationCustom60">
                                    <Form.Label >Compulsory Core Course</Form.Label>
                                    <Form.Control 
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="English"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom61">
                                <Form.Label >Compulsory Subject(AECC)</Form.Label>
                                    <Form.Control 
                                        className="border-info"
                                        type="text"
                                        placeholder="English/MIL Communication (for B.A/B.com)"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom56">
                                    <Form.Label className="required_label">Core Course (Elective Subject-1 for B.A/B.Com)</Form.Label>
                                    <Form.Control 
                                        value={core1} onChange={onCore1Change}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Subject of preference-1"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md="6" controlId="validationCustom56">
                                    <Form.Label className="required_label"></Form.Label>
                                    <Form.Control 
                                        value={core2} onChange={onCore2Change}
                                        className="border-info"
                                        required
                                        type="text"
                                        placeholder="Subject of preference-2"
                                    />
                                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                </Form.Group>
                            </Form.Row>



                            
                            <Button className="btn-lg float-right mb-9" type="submit">Submit Form</Button>
                            <legend  className=" text-warning">
                                By clicking SUBMIT, I hereby declare that the information given in this application is correct to the best of my knowledge and belief. If any discrepancy is found even after the admission, the college authority will have every right to cancel the admission at any moment.
                            </legend>
                        </Form>

                    </div>                
                </div>
            </div>
        </div>
    )
}

export default CommerceForm;